import { Helpers, Metrics, RadioGroup, RadioGroupEvent } from '@origin-digital/style-guide';
import React from 'react';
import styled from 'styled-components';

export interface RadioGroupGridProps {
  name: string;
  value?: string;
  onChange?(e: RadioGroupEvent): void;
}

const Grid = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-content: stretch;
  margin-left: -8px;
  margin-right: -8px;

  margin-bottom: ${Metrics.Spacing.M_X_SM}px;

  & > * {
    margin-bottom: 0;
  }

  ${Helpers.media.SM`
    margin-left: -16px;
    margin-right: -16px;
  `}

  & > div {
    flex-basis: 50%;
    position: relative;
    padding: 8px;
    box-sizing: border-box;
    ${Helpers.media.SM`
      flex-basis: 33%;
    `}
    ${Helpers.media.MD`
      padding: 16px;
    `}
    ${Helpers.media.LG`
      flex-basis: 25%;
    `}
  }
`;

export class RadioGroupGrid extends React.Component<RadioGroupGridProps> {
  onChange(e: RadioGroupEvent) {
    if (this.props.onChange) this.props.onChange(e);
  }

  render() {
    const { name, children, value } = this.props;
    return (
      <Grid>
        <RadioGroup name={name} onChange={this.onChange.bind(this)} value={value}>
          {children}
        </RadioGroup>
      </Grid>
    );
  }
}
